
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/how-to-customize",
      function () {
        return require("private-next-pages/material-ui/customization/how-to-customize.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/how-to-customize"])
      });
    }
  